/* Tippy Type — Klaviyo onsite tracking (ported from the Hydrogen site).
   Fires "Viewed Product" on product pages and "Added to Cart" on any AJAX add.
   Uses the legacy _learnq queue, which Klaviyo's onsite JS drains once loaded —
   so this is a safe no-op until the Klaviyo Shopify app embed is enabled. */
(function () {
  function learnq() {
    return (window._learnq = window._learnq || []);
  }

  // ---- Viewed Product (data injected by the product section) ----
  if (window.__klaviyoViewedProduct) {
    try {
      var vp = window.__klaviyoViewedProduct;
      learnq().push(['track', 'Viewed Product', vp.track]);
      learnq().push(['trackViewedItem', vp.item]);
    } catch (e) {}
  }

  // ---- Added to Cart (intercept all /cart/add.js requests) ----
  if (!window.__tippyKlaviyoAtcHooked) {
    window.__tippyKlaviyoAtcHooked = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var promise = origFetch.apply(this, args);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        promise
          .then(function (res) { return res.clone().json(); })
          .then(function (data) {
            var items = data && data.items ? data.items : data ? [data] : [];
            items.forEach(function (it) {
              if (!it || !it.product_title) return;
              learnq().push(['track', 'Added to Cart', {
                Name: it.product_title,
                ProductID: it.product_id,
                Quantity: it.quantity,
                ItemPrice: it.price / 100,
                ImageURL: it.image,
                URL: window.location.origin + it.url,
                Brand: it.vendor,
                Variant: it.variant_title,
              }]);
            });
          })
          .catch(function () {});
      }
      return promise;
    };
  }
})();
